import { UseMutationResult } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import {
  PersonSearchResultExternalPersonScopeEnum as PersonScopeEnum,
  PersonSearchResultExternal,
  RelationshipCreate,
  RelationshipLabel,
} from '@askporter/client-grieg-lyric';

export type LinkPeopleRelationshipMap = Record<PersonScopeEnum, RelationshipLabel>;

/**
 * Links a batch of people (users/teams/orgs) to a party and resolves once every relationship create has
 * completed, parameterised by the caller's own scope -> relationship label mapping (labels for a "linked to a
 * task" relationship differ from a "linked to an asset" one, for example).
 *
 * @param partyURN - the party URN every person is linked to
 * @param relationshipMap - maps a person's scope (ORG/TEAM/USER) to the relationship label to create
 * @param addRelationship - the react-query mutation function to call
 * @param people - the people to link
 */
export const linkPeopleAsync = async (
  partyURN: string,
  relationshipMap: LinkPeopleRelationshipMap,
  addRelationship: UseMutationResult<AxiosResponse<unknown>, unknown, RelationshipCreate, unknown>,
  people: Array<PersonSearchResultExternal>,
): Promise<void> => {
  await Promise.all(
    people.map((person) =>
      addRelationship.mutateAsync({
        aParty: partyURN,
        relationshipLabel: relationshipMap[person?.personScope],
        bParty: person?.urn,
      }),
    ),
  );
};
